import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { githubUrl, githubUrlPublic } from 'thecodelife/utils';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // for offcanvas behavior
import { FaDownload, FaFileCode, FaGithub } from 'react-icons/fa';
import Markdown from 'react-markdown'
import "./custom.css"
import { Editor } from '@monaco-editor/react';
import { useIsTablet } from 'utils/general';
import JSZip from 'jszip';
import { Link } from 'react-router-dom';

export const AssignmentViewer = () => {
    const { urlKey } = useParams();
    const [files, setFiles] = useState([]);
    const [fileContent, setFileContent] = useState<
        Record<string, string>
    >({});

    useEffect(() => {
        const fetchFiles = async () => {
            const response = await fetch(
                `${githubUrl}/${urlKey}`
            );
            const data = await response.json();
            setFiles(data);
            // get fileContent
            const filePromises = data.map(async (file) => {
                const fileResponse = await fetch(file.download_url);
                const fileData = await fileResponse.text();
                return { name: file.name, content: fileData };
            });
            const fileContents = await Promise.all(filePromises);
            const fileContentMap = {};
            fileContents.forEach((file) => {
                fileContentMap[file.name] = file.content;
            });
            setFileContent(fileContentMap);
        };

        fetchFiles();

    }, []);

    const download = () => {
        const zip = new JSZip();
        files.forEach((file) => {
            zip.file(file.name, fileContent[file.name]);
        });
        zip.generateAsync({ type: "blob" }).then((content) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(content);
            link.download = `${urlKey}.zip`;
            link.click();
        });
    };

    const viewSolution = () => {

    }

    const goToGithub = () => {
        window.open(`${githubUrlPublic}/${urlKey}`, "_blank");
    }

    return (
        <ViewerPage>
            {/* <ButtonRow
                download={download}
                viewSolution={viewSolution}
                goToGithub={goToGithub}
            /> */}
            <Link
                className='d-flex'
                to={"/"}> Back Home </Link>
            <FileViewer>
                {"README.md" in fileContent && (
                    <div>
                        <Markdown>{fileContent["README.md"]}</Markdown>
                    </div>
                )}
                {
                    "main.py" in fileContent && (
                        <div className='w-100 justify-content-left'>
                            <h2>Starter Code</h2>
                            <div className="w-100">
                                <Editor
                                    height="400px"
                                    defaultLanguage="python"
                                    defaultValue={fileContent["main.py"]}
                                    theme="vs-dark"
                                    options={{
                                        minimap: {
                                            enabled: false,
                                        },
                                        automaticLayout: true,
                                        wordWrap: "on",
                                        scrollBeyondLastLine: false
                                    }}
                                />
                            </div>
                        </div>
                    )
                }
            </FileViewer>
        </ViewerPage>
    );
};



const ButtonRow = ({ download, viewSolution, goToGithub }) => {
    const isTablet = useIsTablet();



    return (
        <ButtonBar className={`d-flex  ${isTablet ? "flex-column" : ""}`}>
            <button className="btn btn-primary m-1" onClick={viewSolution}>
                <FaFileCode /> {isTablet ? "" : "Solution"}
            </button>
            <button className="btn btn-secondary m-1" onClick={download}>
                <FaDownload /> {isTablet ? "" : "Download"}
            </button>
            <button className="btn btn-success m-1" onClick={goToGithub}>
                <FaGithub /> {isTablet ? "" : "View on GitHub"}
            </button>
        </ButtonBar>
    )
}

const ViewerPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f0f0;
  min-height: 100vh;
`;

const FileViewer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin-top: 20px;
  max-width: 8in;
`;


const ButtonBar = styled.div`
    position: fixed;
    top: 10px;
    left: 10px;
    border-radius: 8px;
`